/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantContattoDTO
 */
export interface TenantContattoDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    ruolo?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the TenantContattoDTO interface.
 */
export function instanceOfTenantContattoDTO(value: object): value is TenantContattoDTO {
    return true;
}

export function TenantContattoDTOFromJSON(json: any): TenantContattoDTO {
    return TenantContattoDTOFromJSONTyped(json, false);
}

export function TenantContattoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantContattoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'ruolo': json['ruolo'] == null ? undefined : json['ruolo'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function TenantContattoDTOToJSON(value?: TenantContattoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'cognome': value['cognome'],
        'nome': value['nome'],
        'ruolo': value['ruolo'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

